<template>
  <div class="layout-menu-container">
    <AppSubmenu
      v-if="model"
      :items="model"
      class="layout-menu"
      :root="true"
      @menuitem-click="onMenuItemClick"
    />
  </div>
</template>

<script>
import AppSubmenu from "./AppSubmenu";
import { getters, actions } from "./store.js";

export default {
  data() {
    return {
      model: [
        { label: "داشبورد", icon: "pi pi-fw pi-home", to: "/" },
        { label: "ماژول‌ها", icon: "pi pi-fw pi-list", to: "/module/list" },
        { label: "enum", icon: "pi pi-fw pi-list", to: "/enum/list" },
        { label: "نظرات", icon: "pi pi-fw pi-list", to: "/comment/list" },
      ],
    };
  },
  methods: {
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
  },
  components: {
    AppSubmenu: AppSubmenu,
  },
  async mounted() {
    await actions.loadEnums();
    await actions.loadModules();

    this.$emit("menu-loaded");

    const modules = getters.modules();

    modules
      .filter((x) => !x.junction && !x.complexJunction && !x.pluralLabel.includes("نظرات"))
      .map((module) => {
        this.model.push({
          label: module.pluralLabel,
          icon: module.icon,
          to: `/List/${module.name}`,
        });
      });
  },
};
</script>

<style scoped>
</style>